import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    label: {
      textAlign: 'left',
      fontSize: 14
    },
    leftAlignContainer: {
      //左寄せ
      display: 'flex',
      alignItems: 'left',
      justifyContent: 'left',
      marginLeft: -3
    },
    itemMargin: {
      margin: '0px 3px'
    },
    input: {
      width: '100%'
    },
    gridItem: {
      '@media screen and (min-width:600px)': {
        paddingBottom: 30
      },
      '@media screen and (max-width:600px)': {
        paddingBottom: 10
      }
    },
    flexWrap: {
      display: 'flex',
      flexWrap: 'wrap'
    },
    publishedUrlContainer: {
      backgroundColor: 'rgba(0,0,0,0.05)',
      padding: 15,
      borderRadius: 3,
      '@media screen and (min-width:600px)': {
        display: 'flex',
        alignItems: 'center'
      }
    },
    publishedUrlTextContainer: {
      '@media screen and (min-width:600px)': {
        width: 'calc(100% - 115px)',
        marginRight: 15
      },
      minHeight: 100,
      wordBreak: 'break-all',
      fontSize: 14
    },
    copyLinkButton: {
      border: '1px solid gray',
      marginTop: 10,
      fontSize: 12
    },
    copyLinkButtonWrap: {
      '@media screen and (max-width:600px)': {
        textAlign: 'right'
      }
    },
    qrCode: {
      padding: 15,
      backgroundColor: '#FFFFFF',
      width: '100px !important',
      height: '100px !important'
    },
    qrCodeWrapper: {
      textAlign: 'center',
      '@media screen and (max-width:600px)': {
        paddingTop: 15
      }
    }
  });
});
